export default __webpack_public_path__ + "static/1853-7ddf5272076faf01dfaa8dce0e2cde8d.gif";